import BaseGetters from '@/store/base/getters'

export default BaseGetters({
  getRoleBySlug: state => slug => state.module.find(el => el.slug === slug),
  getDefaultRoles: state => state.defaultRoles,
  getSystemRoles: state => state.module.filter(role => role.slug !== 'client')
})